import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ai-templates/CommandPalette.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ai-templates/StackBuilder.tsx");
